module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-21-27d6e5edb460e87fe1be05a598a2007d.svg";